import { useEffect, useContext, useState } from "react"
import { Container, Row, Col, Form, Card, Button, Alert } from "react-bootstrap"
import { authContext } from "../context/AuthContext"
import Get from "../api/Get"
import { GET_GENERIC_TEXT } from "../api/Routes"
import LoadingList from "../loader/LoadingList"
import { Field, Formik } from "formik"
import * as Yup from 'yup';
import { AiFillSave } from "react-icons/ai"
import Post from "../api/Post"
import { toast } from "react-toastify"
import Put from "../api/Put"
import SimpleLoad from "../loader/SimpleLoad"
import { FaCopy } from "react-icons/fa"
import { URL_PAGE } from "../constants/urls"

export default function TextoGenerico(){
    const {auth} = useContext(authContext)
    const [loading, setLoading] = useState(false)
    const [initialValues, setInitialValues] = useState({id: null, description:''})
    const [isDoingSubmitting, setIsDoingSubmitting] = useState(false)


    const checkTextGenerico = async () => {
        setLoading(true)
        try {
            const resp = await Get({url: `${GET_GENERIC_TEXT}/1` , access_token: auth.data.access_token})
            if(resp.data.state){
                setInitialValues({
                    id: resp.data.data.id,
                    description: resp.data.data.description
                })
            }else{
                setInitialValues({
                    id: null,
                    description: ''
                })
            }
            setLoading(false)
        } catch (error) {
            setInitialValues({
                id: null,
                description: ''
            })
            setLoading(false)
        }
        
    }

    useEffect(() => {
        checkTextGenerico()
    }, [])
    const shemaValidate = Yup.object().shape({description:Yup.string().required('Campo Requerido')});

    const copyClipboad = async () =>{
        try {
            const r = await navigator.clipboard.writeText(`${URL_PAGE}/public/cita/mensaje`)
            console.log(r)
            toast.success("Link copiado", {autoClose: 3000})    
        } catch (error) {
            toast.error('Ocurrió un error mientras se copiaba el link. Por favor revise los permisos del navegador', {autoClose: 10000})
        }        
    }

    return (
        <>
         {loading && <LoadingList texto='' />}
         <Container fluid className="my-5">
            <Row>
                <Col xs="12" md="12">
                    {!loading && 
                    <Formik 
                        initialValues={initialValues}
                        enableReinitialize
                        validationSchema={shemaValidate}
                        onSubmit={(values, { setSubmitting, setFieldValue }) => { 
                            console.log(values)  
                            setIsDoingSubmitting(true) 
                            if(values.id){
                                Put({url: `${GET_GENERIC_TEXT}/update`, data: values, header:true, access_token:auth.data.access_token})
                                .then((response) => {   
                                    toast.success("Acción exitosa")  
                                    setIsDoingSubmitting(false)
                                })                
                                .catch((error) => {
                                    console.log("Error encontrado", error)
                                    toast.error("Error server")
                                    setIsDoingSubmitting(false)
                                })
                            } else{
                                Post({url: `${GET_GENERIC_TEXT}/save`, data: values, header:true, access_token:auth.data.access_token})
                                .then((response) => {  
                                    toast.success("Acción exitosa")  
                                    setIsDoingSubmitting(false)
                                })                
                                .catch((error) => {
                                    console.log("Error encontrado", error)
                                    toast.error("Error server")
                                    setIsDoingSubmitting(false)
                                })
                            }                            
                        }}
                    >{({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting,
                        setFieldValue
                    }) => (
                        <Form onSubmit={handleSubmit}  className='mt-3'>
                            {isDoingSubmitting && <SimpleLoad />}
                            <Card className="shadow-1 formSection">
                                <Card.Body>
                                    <Row>
                                        <Col xs="12" md="12">
                                            <h4><span className="subtitulo">Texto genérico</span></h4>
                                        </Col>
                                    </Row>
                                    <div className="body">
                                        <Row>
                                            <Col xs="12" md="12">
                                                <Form.Group>
                                                    <Form.Label className="font-weight-bold-600 text-secondary">Descripción</Form.Label>
                                                    <Field 
                                                        type="text"
                                                        className={`form-control input-form ${errors.description && 'error'}`}
                                                        name="description"
                                                    />
                                                    { errors.description && <div className="invalid-feedback d-block">{errors.description}</div> }
                                                </Form.Group>
                                            </Col>
                                            <Col  xs="12" md="5">
                                                <Alert variant="info">
                                                    <div className="d-flex">
                                                        <div className="flex-grow-1">{`${URL_PAGE}/public/cita/mensaje`}</div>
                                                        <div className="ml-2"><FaCopy onClick={copyClipboad}/></div>
                                                    </div>
                                                </Alert>
                                            </Col>
                                            <Col xs="12" md="12">
                                                <Button type="submit" variant="link" className='btn-add float-right'>
                                                    <AiFillSave className="icon-save"/>
                                                </Button>{''}
                                            </Col>
                                        </Row>
                                    </div>   
                                </Card.Body>
                            </Card>
                        </Form>
                    )}</Formik>
                    }
                </Col>
               
            </Row>
        </Container>
        </>
        
    )
}